@file:Suppress("DEPRECATION")
package org.example.newportfolio.theme.icons

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.dom.svg.Path
import com.varabyte.kobweb.compose.dom.svg.SVGFillRule
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.icons.IconRenderStyle
import com.varabyte.kobweb.silk.components.icons.createIcon
import com.varabyte.kobweb.silk.components.style.toModifier

@Composable
fun TelegramIcon(
    modifier: Modifier = IconStyle.toModifier(),
    iconRenderStyle: IconRenderStyle = IconRenderStyle.Fill()
) {
    createIcon(renderStyle = iconRenderStyle, attrs = modifier.toAttrs()) {
        Path {
            fillRule(SVGFillRule.EvenOdd)
            d(
                "M24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12ZM12.43 8.85893C11.2628 9.3444 8.93014 10.3492 5.43189 11.8733C4.86383 12.0992 4.56626 12.3202 4.53917 12.5363C4.49339 12.9015 4.95071 13.0453 5.57347 13.2411C5.65818 13.2678 5.74595 13.2954 5.83594 13.3246C6.44864 13.5238 7.27283 13.7568 7.70129 13.766C8.08994 13.7744 8.52373 13.6142 9.00264 13.2853C12.2712 11.079 13.9584 9.96381 14.0643 9.93977C14.139 9.92281 14.2426 9.90148 14.3128 9.96385C14.3829 10.0262 14.376 10.1443 14.3686 10.176C14.3233 10.3691 12.5281 12.0381 11.5991 12.9018C11.3095 13.171 11.1041 13.362 11.0621 13.4056C10.968 13.5033 10.8721 13.5958 10.78 13.6846C10.2108 14.2333 9.78391 14.6448 10.8036 15.3168C11.2936 15.6397 11.6858 15.9067 12.077 16.1731C12.5042 16.4641 12.9303 16.7543 13.4816 17.1157C13.6221 17.2077 13.7562 17.3034 13.8869 17.3965C14.3841 17.751 14.8307 18.0694 15.3826 18.0186C15.7032 17.9891 16.0345 17.6876 16.2027 16.7884C16.6002 14.6631 17.3816 10.0585 17.5622 8.16097C17.578 7.99473 17.5581 7.78197 17.5422 7.68857C17.5262 7.59518 17.4928 7.46211 17.3714 7.3636C17.2276 7.24694 17.0056 7.22234 16.9064 7.22408C16.455 7.23203 15.7626 7.47282 12.43 8.85893Z"
            )
        }
    }
}

@Composable
fun EmailIcon(
    modifier: Modifier = IconStyle.toModifier(),
    iconRenderStyle: IconRenderStyle = IconRenderStyle.Fill()
) {
    createIcon(renderStyle = iconRenderStyle, attrs = modifier.toAttrs()) {
        Path {
            d("M1 5.88269L12 12L23 5.88269C22.9593 5.10302 22.6521 4.37018 22.1414 3.83425C21.6308 3.29832 20.9552 2.99986 20.2531 3H3.74691C3.04482 2.99986 2.36924 3.29832 1.85856 3.83425C1.34787 4.37018 1.04072 5.10302 1 5.88269Z")
        }
        Path {
            d("M23 9L12 14.5823L1 9V17.2088C1 17.9492 1.28973 18.6591 1.80546 19.1826C2.32118 19.7059 3.02066 20 3.75 20H20.25C20.9793 20 21.6788 19.7059 22.1945 19.1826C22.7103 18.6591 23 17.9492 23 17.2088V9Z")
        }
    }
}

@Composable
fun GitHubIcon(
    modifier: Modifier = IconStyle.toModifier(),
    iconRenderStyle: IconRenderStyle = IconRenderStyle.Fill()
) {
    createIcon(renderStyle = iconRenderStyle, attrs = modifier.toAttrs()) {
        Path {
            fillRule(SVGFillRule.EvenOdd)
            d("M12 0.957031C5.74743 0.957031 0.677246 6.02609 0.677246 12.2798C0.677246 17.2827 3.92156 21.5267 8.42043 23.0241C8.98612 23.1291 9.19387 22.7785 9.19387 22.4794C9.19387 22.2094 9.18337 21.3175 9.1785 20.3713C6.0285 21.0563 5.36381 19.0354 5.36381 19.0354C4.84875 17.7267 4.10662 17.3787 4.10662 17.3787C3.07912 16.6759 4.18406 16.6905 4.18406 16.6905C5.32087 16.7702 5.91975 17.8573 5.91975 17.8573C6.92962 19.588 8.56856 19.0877 9.21468 18.7986C9.31631 18.0668 9.60975 17.5671 9.93356 17.2843C7.41862 16.9984 4.77468 16.0273 4.77468 11.6888C4.77468 10.4526 5.21718 9.44253 5.9415 8.64941C5.82375 8.36441 5.43618 7.21278 6.051 5.65316C6.051 5.65316 7.00162 5.34884 9.16537 6.81378C10.0687 6.56272 11.0376 6.43653 12 6.43222C12.9619 6.43653 13.9312 6.56234 14.8363 6.81341C16.9974 5.34847 17.9469 5.65278 17.9469 5.65278C18.5632 7.21222 18.1757 8.36403 18.0581 8.64903C18.7841 9.44216 19.2234 10.4522 19.2234 11.6884C19.2234 16.0373 16.5746 16.9947 14.0533 17.2752C14.4596 17.6265 14.8215 18.3158 14.8215 19.372C14.8215 20.887 14.8084 22.1063 14.8084 22.4792C14.8084 22.7805 15.0124 23.1336 15.5861 23.0224C20.0824 21.5235 23.3229 17.2808 23.3229 12.2798C23.3227 6.02647 18.2531 0.957031 12 0.957031Z")
        }
    }
}

@Composable
fun ExternalLinkIcon(
    modifier: Modifier = IconStyle.toModifier(),
    iconRenderStyle: IconRenderStyle = IconRenderStyle.Fill()
) {
    createIcon(renderStyle = iconRenderStyle, attrs = modifier.toAttrs()) {
        Path {
            d("M16.5 12.9002C16.5 12.4031 16.9029 12.0002 17.4 12.0002C17.8971 12.0002 18.3 12.4031 18.3 12.9002V18.3002C18.3 19.7914 17.0912 21.0002 15.6 21.0002H5.7C4.20883 21.0002 3 19.7914 3 18.3002V8.4002C3 6.90903 4.20883 5.7002 5.7 5.7002H11.1C11.5971 5.7002 12 6.10314 12 6.6002C12 7.09725 11.5971 7.5002 11.1 7.5002H5.7C5.20294 7.5002 4.8 7.90314 4.8 8.4002V18.3002C4.8 18.7973 5.20294 19.2002 5.7 19.2002H15.6C16.0971 19.2002 16.5 18.7973 16.5 18.3002V12.9002Z")
        }
        Path {
            d("M19.1998 4.8H14.6998C14.2027 4.8 13.7998 4.39706 13.7998 3.9C13.7998 3.40294 14.2027 3 14.6998 3H20.0998C20.5969 3 20.9998 3.40294 20.9998 3.9V9.3C20.9998 9.79706 20.5969 10.2 20.0998 10.2C19.6027 10.2 19.1998 9.79706 19.1998 9.3V4.8Z")
        }
        Path {
            d("M10.8362 14.4364C10.4847 14.7879 9.91488 14.7879 9.56341 14.4364C9.21194 14.0849 9.21194 13.5151 9.56341 13.1636L19.4634 3.2636C19.8149 2.91213 20.3847 2.91213 20.7362 3.2636C21.0877 3.61508 21.0877 4.18492 20.7362 4.5364L10.8362 14.4364Z")
        }
    }
}

@Composable
fun ScrollMouseIcon(
    modifier: Modifier = IconStyle.toModifier(),
    iconRenderStyle: IconRenderStyle = IconRenderStyle.Fill()
) {
    createIcon(renderStyle = iconRenderStyle, attrs = modifier.toAttrs()) {
        Path {
            d("M15.6002 9.84001C15.6002 7.94401 14.1122 6.38401 12.2402 6.26401V10.32H15.6002V9.84001Z")
        }
        Path {
            d("M8.3999 9.84001V10.32H11.7599V6.26401C9.8879 6.38401 8.3999 7.94401 8.3999 9.84001Z")
        }
        Path {
            d("M15.5999 14.16V10.8H8.3999V14.16C8.3999 16.152 10.0079 17.76 11.9999 17.76C13.9919 17.76 15.5999 16.152 15.5999 14.16Z")
        }
        Path {
            d("M12.8638 19.824L11.9998 20.688L11.1358 19.824C10.9438 19.632 10.6558 19.632 10.4638 19.824C10.2718 20.016 10.2718 20.304 10.4638 20.496L11.6638 21.696C11.7598 21.792 11.8798 21.84 11.9998 21.84C12.1198 21.84 12.2398 21.792 12.3358 21.696L13.5358 20.496C13.7278 20.304 13.7278 20.016 13.5358 19.824C13.3438 19.632 13.0558 19.632 12.8638 19.824Z")
        }
        Path {
            d("M12.3358 2.304C12.1438 2.112 11.8558 2.112 11.6638 2.304L10.4638 3.504C10.2718 3.696 10.2718 3.984 10.4638 4.176C10.5598 4.272 10.6798 4.32 10.7998 4.32C10.9198 4.32 11.0398 4.272 11.1358 4.176L11.9998 3.312L12.8638 4.176C12.9598 4.272 13.0798 4.32 13.1998 4.32C13.3198 4.32 13.4398 4.272 13.5358 4.176C13.7278 3.984 13.7278 3.696 13.5358 3.504L12.3358 2.304Z")
        }
    }
}

@Composable
fun ArrowForwardIcon(
    modifier: Modifier = IconStyle.toModifier(),
    iconRenderStyle: IconRenderStyle = IconRenderStyle.Fill()
) {
    createIcon(renderStyle = iconRenderStyle, attrs = modifier.toAttrs()) {
        Path {
            d(
                "M16.175 13H5C4.71667 13 4.47917 12.9042 4.2875 12.7125C4.09583 12.5208 4 12.2833 4 12C4 11.7167 4.09583 11.4792 4.2875 11.2875C4.47917 11.0958 4.71667 11 5 11H16.175L11.275 6.09999C11.075 5.89999 10.9792 5.66665 10.9875 5.39999C10.9958 5.13332 11.1 4.89999 11.3 4.69999C11.5 4.51665 11.7333 4.42082 12 4.41249C12.2667 4.40415 12.5 4.49999 12.7 4.69999L19.3 11.3C19.4 11.4 19.4708 11.5083 19.5125 11.625C19.5542 11.7417 19.575 11.8667 19.575 12C19.575 12.1333 19.5542 12.2583 19.5125 12.375C19.4708 12.4917 19.4 12.6 19.3 12.7L12.7 19.3C12.5167 19.4833 12.2875 19.575 12.0125 19.575C11.7375 19.575 11.5 19.4833 11.3 19.3C11.1 19.1 11 18.8625 11 18.5875C11 18.3125 11.1 18.075 11.3 17.875L16.175 13Z"
            )
        }
    }
}

@Composable
fun HamburgerIcon(
    modifier: Modifier = IconStyle.toModifier(),
    iconRenderStyle: IconRenderStyle = IconRenderStyle.Fill(),
) {
    createIcon(renderStyle = iconRenderStyle, attrs = modifier.toAttrs()) {
        Path {
            d(
                "M3.46657 19.2C3.16435 19.2 2.91101 19.085 2.70657 18.855C2.50212 18.625 2.3999 18.34 2.3999 18C2.3999 17.66 2.50212 17.375 2.70657 17.145C2.91101 16.915 3.16435 16.8 3.46657 16.8H20.5332C20.8355 16.8 21.0888 16.915 21.2932 17.145C21.4977 17.375 21.5999 17.66 21.5999 18C21.5999 18.34 21.4977 18.625 21.2932 18.855C21.0888 19.085 20.8355 19.2 20.5332 19.2H3.46657ZM3.46657 13.2C3.16435 13.2 2.91101 13.085 2.70657 12.855C2.50212 12.625 2.3999 12.34 2.3999 12C2.3999 11.66 2.50212 11.375 2.70657 11.145C2.91101 10.915 3.16435 10.8 3.46657 10.8H20.5332C20.8355 10.8 21.0888 10.915 21.2932 11.145C21.4977 11.375 21.5999 11.66 21.5999 12C21.5999 12.34 21.4977 12.625 21.2932 12.855C21.0888 13.085 20.8355 13.2 20.5332 13.2H3.46657ZM3.46657 7.19999C3.16435 7.19999 2.91101 7.08499 2.70657 6.85499C2.50212 6.62499 2.3999 6.33999 2.3999 5.99999C2.3999 5.65999 2.50212 5.37499 2.70657 5.14499C2.91101 4.91499 3.16435 4.79999 3.46657 4.79999H20.5332C20.8355 4.79999 21.0888 4.91499 21.2932 5.14499C21.4977 5.37499 21.5999 5.65999 21.5999 5.99999C21.5999 6.33999 21.4977 6.62499 21.2932 6.85499C21.0888 7.08499 20.8355 7.19999 20.5332 7.19999H3.46657Z"
            )
        }
    }
}

@Composable
fun DarkModeIcon(
    modifier: Modifier = Modifier,
    iconRenderStyle: IconRenderStyle = IconRenderStyle.Fill(),
) {
    createIcon(renderStyle = iconRenderStyle, attrs = modifier.toAttrs()) {
        Path {
            d("M12 21C9.5 21 7.375 20.125 5.625 18.375C3.875 16.625 3 14.5 3 12C3 9.5 3.875 7.375 5.625 5.625C7.375 3.875 9.5 3 12 3C12.2333 3 12.4625 3.00833 12.6875 3.025C12.9125 3.04167 13.1333 3.06667 13.35 3.1C12.6667 3.58333 12.1208 4.2125 11.7125 4.9875C11.3042 5.7625 11.1 6.6 11.1 7.5C11.1 9 11.625 10.275 12.675 11.325C13.725 12.375 15 12.9 16.5 12.9C17.4167 12.9 18.2583 12.6958 19.025 12.2875C19.7917 11.8792 20.4167 11.3333 20.9 10.65C20.9333 10.8667 20.9583 11.0875 20.975 11.3125C20.9917 11.5375 21 11.7667 21 12C21 14.5 20.125 16.625 18.375 18.375C16.625 20.125 14.5 21 12 21Z")
        }
    }
}

@Composable
fun LightModeIcon(
    modifier: Modifier = Modifier,
    iconRenderStyle: IconRenderStyle = IconRenderStyle.Fill(),
) {
    createIcon(renderStyle = iconRenderStyle, attrs = modifier.toAttrs()) {
        Path {
            d("M12 17C10.6167 17 9.4375 16.5125 8.4625 15.5375C7.4875 14.5625 7 13.3833 7 12C7 10.6167 7.4875 9.4375 8.4625 8.4625C9.4375 7.4875 10.6167 7 12 7C13.3833 7 14.5625 7.4875 15.5375 8.4625C16.5125 9.4375 17 10.6167 17 12C17 13.3833 16.5125 14.5625 15.5375 15.5375C14.5625 16.5125 13.3833 17 12 17ZM5 13H1V11H5V13ZM23 13H19V11H23V13ZM11 5V1H13V5H11ZM11 23V19H13V23H11ZM6.4 7.75L3.875 5.325L5.3 3.85L7.7 6.35L6.4 7.75ZM18.7 20.15L16.275 17.625L17.6 16.25L20.125 18.675L18.7 20.15ZM16.25 6.4L18.675 3.875L20.15 5.3L17.65 7.7L16.25 6.4ZM3.85 18.7L6.375 16.275L7.75 17.6L5.325 20.125L3.85 18.7Z")
        }
    }
}